import React from "react";

import { Image } from "@vw-marketing/us-components";

import { StyledImageContainer } from "./styles";

export const ImageContainer = ({ imgSource }: { imgSource: string }) => {
  return (
    <StyledImageContainer>
      <Image src={imgSource} alt="Vehicle Image" />
    </StyledImageContainer>
  );
};
